import { render, staticRenderFns } from "./ConsentDetail.vue?vue&type=template&id=10eeba1c&scoped=true&"
import script from "./ConsentDetail.vue?vue&type=script&lang=js&"
export * from "./ConsentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConsentDetail.vue?vue&type=style&index=0&id=10eeba1c&prod&lang=css&"
import style1 from "./ConsentDetail.vue?vue&type=style&index=1&id=10eeba1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eeba1c",
  null
  
)

export default component.exports